// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuestionStyles-cls1__bc8eded01d33a7b3d014{/*!*/}.QuestionStyles-cls2__ec08a0aa32248b9311dd{display:flex;flex-direction:column}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "QuestionStyles-cls1__bc8eded01d33a7b3d014",
	"cls2": "QuestionStyles-cls2__ec08a0aa32248b9311dd QuestionStyles-cls1__bc8eded01d33a7b3d014"
};
export default ___CSS_LOADER_EXPORT___;
